import React from 'react'
import ReactSelect from 'react-select'

function Select({
  placeholder,
  options,
  defaultValue,
  isMulti,
  onChange,
  isDisabled,
}) {
  const indicatorSeparatorStyle = {
    alignSelf: 'stretch',
    backgroundColor: '#ffffff',
    marginBottom: 8,
    marginTop: 8,
    width: 1,
  }

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />
  }

  const styles = {
    multiValue: (base, state) => {
      return state.data.isFixed ? { ...base, backgroundColor: 'gray' } : base
    },
    multiValueLabel: (base, state) => {
      return state.data.isFixed
        ? { ...base, fontWeight: 'bold', color: 'white', paddingRight: 6 }
        : base
    },
    multiValueRemove: (base, state) => {
      return state.data.isFixed ? { ...base, display: 'none' } : base
    },
  }

  return (
    <ReactSelect
      styles={styles}
      isDisabled={isDisabled}
      closeMenuOnSelect={!isMulti}
      components={{ IndicatorSeparator }}
      defaultValue={defaultValue}
      isMulti={isMulti}
      options={options}
      placeholder={placeholder || 'Select...'}
      onChange={onChange}
    />
  )
}

export default Select
